import React, { useEffect, useMemo, useRef, useState } from 'react';
import triangleDownIcon from '../../../../assets/images/triangle-down.svg';
import '../Styles/ProductSelectDropdown.scss';

const ProductSelectDropdown = ({
    label,
    options = [],
    selectedValue = null,
    onChange = () => {},
    placeholder = 'Chọn sản phẩm',
    disabled = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };

        if (isOpen && !disabled) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, selectedValue, disabled]);

    const filteredOptions = useMemo(() => {
        if (!searchTerm.trim()) {
            return options;
        }
        const term = searchTerm.toLowerCase();
        return options.filter((option) => option.label.toLowerCase().includes(term));
    }, [options, searchTerm]);

    const currentDisplay = useMemo(() => {
        const found = options.find((option) => option.value === selectedValue);
        return found ? found.label : '';
    }, [selectedValue, options]);

    const handleClear = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onChange(null);
    };

    const handleOptionToggle = (value, isChecked) => {
        const nextValue = isChecked ? value : null;
        onChange(nextValue);
        setIsOpen(false);
        setSearchTerm('');
    };

    return (
        <div className={`multi-select-dropdown product-select-dropdown ${disabled ? 'is-disabled' : ''}`} ref={dropdownRef}>
            <div className={`multi-select-field ${selectedValue ? 'has-selection' : ''}`}>
                <label className={!selectedValue ? 'no-selection' : ''}>{label}</label>
                <div
                    className={`multi-select-display ${isOpen ? 'is-open' : ''}`}
                    onClick={() => {
                        if (disabled) {
                            return;
                        }
                        setIsOpen(!isOpen);
                    }}
                >
                    {currentDisplay ? (
                        <div className="multi-select-chip" onClick={(e) => e.stopPropagation()}>
                            <span>{currentDisplay}</span>
                            {!disabled && (
                                <button
                                    type="button"
                                    className="chip-remove"
                                    onClick={handleClear}
                                    aria-label="Xóa lựa chọn"
                                >
                                </button>
                            )}
                        </div>
                    ) : (
                        <span className="display-text">{placeholder}</span>
                    )}
                    <img
                        src={triangleDownIcon}
                        alt=""
                        aria-hidden="true"
                        className="chevron-icon"
                    />
                </div>
            </div>

            {isOpen && (
                <div className="multi-select-modal product-select-modal">
                    <div className="modal-search">
                        <input
                            type="text"
                            placeholder="Tìm kiếm sản phẩm"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                    </div>

                    <div className="modal-scrollable-content">
                        <div className="modal-list">
                            {filteredOptions.length === 0 ? (
                                <div className="empty-list">Không tìm thấy sản phẩm</div>
                            ) : (
                                filteredOptions.map((option) => (
                                    <label
                                        key={option.value}
                                        className={`modal-list-item ${selectedValue === option.value ? 'is-selected' : ''}`}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedValue === option.value}
                                            onChange={(e) => handleOptionToggle(option.value, e.target.checked)}
                                        />
                                        <span>{option.label}</span>
                                    </label>
                                ))
                            )}
                        </div>
                    </div>

                </div>
            )}
        </div>
    );
};

export default ProductSelectDropdown;


